import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  OverlayTrigger,
  Tooltip,
  Carousel,
  Offcanvas,
} from "react-bootstrap";
import { motion } from "framer-motion";

const techSlides = {
  figma: {
    title: "Design with Figma",
    text: "Collaborate on modern UI/UX designs with real-time feedback.",
    buttonText: "Explore Figma",
  },
  html5: {
    title: "Build with HTML5",
    text: "Create responsive and semantic web pages using HTML5.",
    buttonText: "Learn HTML5",
  },
  "tailwind-css": {
    title: "Style with Tailwind",
    text: "Use utility-first CSS for rapid and responsive design.",
    buttonText: "Start Tailwind",
  },
  aws: {
    title: "Deploy with AWS",
    text: "Scale applications securely using Amazon Web Services.",
    buttonText: "Try AWS",
  },
  javascript: {
    title: "Code with JavaScript",
    text: "Build dynamic and interactive websites effortlessly.",
    buttonText: "Master JS",
  },
  angular: {
    title: "Develop with Angular",
    text: "Powerful framework for building scalable web apps.",
    buttonText: "Learn Angular",
  },
  python: {
    title: "Automate with Python",
    text: "Build apps, data pipelines, and AI with Python.",
    buttonText: "Explore Python",
  },
  bootstrap: {
    title: "UI with Bootstrap",
    text: "Use Bootstrap to build responsive mobile-first websites.",
    buttonText: "Try Bootstrap",
  },
  react: {
    title: "React for Frontend",
    text: "Build interactive UIs with React and component reusability.",
    buttonText: "Learn React",
  },
  java: {
    title: "Code in Java",
    text: "Robust language for enterprise-level applications.",
    buttonText: "Start Java",
  },
  "c-plus-plus": {
    title: "Program in C++",
    text: "Efficient and powerful programming for system-level apps.",
    buttonText: "Explore C++",
  },
};

// ✅ Slider Component
function Slider({ activeSlide }) {
  return (
    <div className="slider-full">
      <Carousel controls={false} indicators={false} fade interval={3000}>
        <Carousel.Item>
          <h1 className="fw-bold display-4">{activeSlide.title}</h1>
          <p className="text-muted fs-5">{activeSlide.text}</p>

          {/* Two buttons side by side */}
          <div className="d-flex gap-3 justify-content-center justify-content-lg-start ">
            <Button size="lg" className="btn-grad border-0  ">
              {activeSlide.buttonText}
            </Button>
            <Button size="lg" className="btn-grad border-0">
              Learn More
            </Button>
          </div>
        </Carousel.Item>
      </Carousel>
    </div>
  );
}


// ✅ Main Component
function Herosection() {
  const techIcons = [
    "figma",
    "html5",
    "tailwind-css",
    "aws",
    "javascript",
    "angular",
    "python",
    "bootstrap",
    "react",
    "java",
    "c-plus-plus",
  ];

  const [show, setShow] = useState(false);
  const [activeSlide, setActiveSlide] = useState(techSlides.react);
  const [currentIndex, setCurrentIndex] = useState(8); // default React index
  const [isHovered, setIsHovered] = useState(false);

  // Auto cycle through slides every 3s
  useEffect(() => {
    if (isHovered) return; // pause auto-slide when hovering
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % techIcons.length;
        setActiveSlide(techSlides[techIcons[nextIndex]]);
        return nextIndex;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [isHovered, techIcons]);

  return (
    <>
      {/* Right Sidebar */}
      <Offcanvas show={show} onHide={() => setShow(false)} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Sidebar</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body> This sidebar opens from the right side. </Offcanvas.Body>
      </Offcanvas>

      {/* Hero Section */}
      <div
        className="hero "
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/bg1.jpg)` }}
      >
        <Container className="hero-section1 d-flex flex-column-reverse ">
          <Row className="align-items-center gy-5">
            {/* Text / Slider */}
            <Col xs={12} lg={6} className="text-content text-center text-lg-start">
              <Slider activeSlide={activeSlide} />
            </Col>

            {/* Rotating Wheel */}
            <Col xs={12} lg={6} className="text-center">
              <div className="wheel-container mx-auto">
                <div className="center-image">
                  <img
                    src={`${process.env.PUBLIC_URL}/laptop.jpg`}
                    alt="Laptop"
                    className="laptop-image"
                  />
                  <div className="code-overlay">
                    <pre className="code-content">{`
function helloWorld() {
  console.log("Hello, World!");
}
                    `}</pre>
                  </div>
                </div>

                <motion.div
                  className="wheel mt-4"
                  animate={isHovered ? { rotate: 0 } : { rotate: 360 }} // no rotation when hovered
                  transition={
                    isHovered
                      ? { duration: 0 } // stop instantly
                      : { repeat: Infinity, duration: 50, ease: "linear" } // keep rotating
                  }
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  {techIcons.map((icon, i) => (
                    <OverlayTrigger
                      key={i}
                      placement="top"
                      overlay={<Tooltip id={`tooltip-${i}`}>{icon.toUpperCase()}</Tooltip>}
                    >
                      <div
                        className={`icon icon-${i + 1}`}
                        onMouseEnter={() => setActiveSlide(techSlides[icon])}
                      >
                        <i className={`bx bxl-${icon} bx-spin`} />
                      </div>

                    </OverlayTrigger>
                  ))}
                </motion.div>


              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Herosection;
